import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Sammensætter klassenavne og lader senere Tailwind-klasser vinde over
 * tidligere. Uden `twMerge` ville `cn('p-2', 'p-4')` give begge klasser, og
 * resultatet ville afhænge af rækkefølgen i den genererede CSS.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
